import React from 'react';
import styled from 'styled-components';
import {createSelector} from 'reselect';

// HOOKS
import {useSelector} from 'react-redux';

// COMPONENTS
import ArrowRight from './ArrowRightIcon';
// import BreadcrumbsDetailsLoader from '../../../../../stories/components/hotels/Loadingpage/BreadcrumbDetails/BreadcrumbDetailsLoader';

import {
  ArrowWrapper,
  BreadCrumbContainer,
  BreadCrumbList,
  BreadCrumbItemLink,
  BreadCrumbATagItemLink,
  // BreadCrumbItemAnchorTag,
  NoLinkBreadcrumbListItem,
} from './style';

// COLOR PALETTE AND THEME
import {defaultTheme} from '@stencil/build-theme';
// TYPES
import {LinkProps} from 'react-router-dom';

type BreadCrumbProps = {
  data: Array<{
    href?: string;
    name: string;
    routeUrl?: string;
  }>;
  disableLastLink?: boolean;
};

type BreadCrumbItemType = {
  children: React.ReactNode;
  to: LinkProps['to'];
  positionForStructuredSEO: string;
};

type BreadCrumbItemAnchorType = {
  children: React.ReactText;
  href: string;
  positionForStructuredSEO: string;
};

export const listItemSEOProps = {
  itemScope: true,
  itemProp: 'itemListElement',
  itemType: 'http://schema.org/ListItem',
};

const BreadCrumbItem: React.FC<BreadCrumbItemType> = ({children, to, positionForStructuredSEO}) => (
  <li {...listItemSEOProps}>
    <BreadCrumbItemLink to={to} itemProp="item">
      <span itemProp="name">{children}</span>
    </BreadCrumbItemLink>
    <meta itemProp="position" content={positionForStructuredSEO} />
  </li>
);

// const BreadCrumbItemAnchor: React.FC<BreadCrumbItemAnchorType> = ({
//   children,
//   href,
//   positionForStructuredSEO,
// }) => (
//   <li {...listItemSEOProps}>
//     <BreadCrumbItemAnchorTag href={href} itemProp="item">
//       <span itemProp="name">{children}</span>
//     </BreadCrumbItemAnchorTag>
//     <meta itemProp="position" content={positionForStructuredSEO} />
//   </li>
// );

type NativeAnchorBreadCrumbItemType = {
  children: React.ReactNode;
  href: string;
  positionForStructuredSEO: string;
};

const NativeAnchorBreadCrumbItem: React.FC<NativeAnchorBreadCrumbItemType> = ({
  children,
  href,
  positionForStructuredSEO,
}) => (
  <li {...listItemSEOProps}>
    <BreadCrumbATagItemLink href={href} itemProp="item">
      <span itemProp="name">{children}</span>
    </BreadCrumbATagItemLink>
    <meta itemProp="position" content={positionForStructuredSEO} />
  </li>
);

type NoLinkBreadcrumbItemTypes = {
  children: React.ReactNode;
  positionForStructuredSEO: string;
};

const NoLinkBreadcrumbItem: React.FC<NoLinkBreadcrumbItemTypes> = ({
  children,
  positionForStructuredSEO,
}) => (
  <NoLinkBreadcrumbListItem {...listItemSEOProps}>
    <span itemProp="name">{children}</span>
    <meta itemProp="position" content={positionForStructuredSEO} />
  </NoLinkBreadcrumbListItem>
);

const RightArrow = () => (
  <ArrowWrapper>
    <ArrowRight width={'1rem'} fill={defaultTheme.colors.downriver.dark} />
  </ArrowWrapper>
);

const Breadcrumb: React.FC<BreadCrumbProps> = ({data, disableLastLink = false}) => {
  return (
    <BreadCrumbContainer itemScope itemType="https://schema.org/breadcrumb">
      <BreadCrumbList itemScope itemType="http://schema.org/BreadcrumbList">
        {data.map(({href, name, routeUrl}, index) => {
          let rightArrow = (!!index && <RightArrow />) || null;
          let disableLastLinkFlag = disableLastLink && index === data.length - 1;
          if (routeUrl && !disableLastLinkFlag)
            return (
              <BreadCrumbItem to={routeUrl} positionForStructuredSEO={`${index + 1}`}>
                <>
                  {rightArrow}
                  <span>{name}</span>
                </>
              </BreadCrumbItem>
            );

          if (href && !disableLastLinkFlag)
            return (
              <NativeAnchorBreadCrumbItem positionForStructuredSEO={`${index + 1}`} href={href}>
                <>
                  {rightArrow}
                  <span>{name}</span>
                </>
              </NativeAnchorBreadCrumbItem>
            );

          return (
            <NoLinkBreadcrumbItem positionForStructuredSEO={`${index + 1}`}>
              {rightArrow}
              <span>{name}</span>
            </NoLinkBreadcrumbItem>
          );
        })}
        {/* <BreadCrumbItemAnchor href="/" positionForStructuredSEO="1">
            Goibibo
          </BreadCrumbItemAnchor>*/}
      </BreadCrumbList>
    </BreadCrumbContainer>
  );
};

export default Breadcrumb;
